module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_20.36dccfb5.gif";